"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconCart = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M3.997 21.09 4.894 7l2.531-.005A17.4 17.4 0 0 0 7.01 10.5a.5.5 0 1 0 .998 0c0-.035.017-1.735.454-3.506l7.077-.013c.44 1.776.457 3.484.457 3.519a.5.5 0 1 0 .998 0c0-.15-.013-1.75-.42-3.521l2.504-.005.96 14.026zM12.001 3c1.708 0 2.684 1.395 3.243 2.98l-6.492.013C9.312 4.402 10.29 3 12.001 3m8.071 3.917a.955.955 0 0 0-.964-.943h-.001l-2.808.006C15.654 3.948 14.412 2 12.001 2 9.583 2 8.34 3.958 7.697 5.995L4.893 6c-.531 0-.963.423-.962.91L3 21.057c0 .52.432.943.964.943h16.073a.96.96 0 0 0 .963-.975z" })] })));
};
exports.IconCart = IconCart;
exports.IconCart.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconCart;
